import { useContext } from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { Context } from '..';

const ProtectedRoute: React.FC = ({ children }) => {
  const { store } = useContext(Context);
  const location = useLocation();

  if (!store.isAuth) {
    // Зберегти цільовий маршрут
    store.setRedirectPath(location.pathname);
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
